import type { WealthicaAccount, WealthicaConnection } from '@/providers/wealthica2/types';

// Define status union locally to avoid importing store types (prevents circular deps)
type ConnectionStatusType =
  | 'idle'
  | 'connecting'
  | 'connected'
  | 'loading_accounts'
  | 'disconnected'
  | 'error'
  | 'pending';

// Minimal utility to create the initial per-connection state without importing the store
// Avoid importing types from the store to prevent circular dependencies
export const createInitialConnectionState = (
  connectionData: WealthicaConnection,
  bearerToken: string,
  institutionId: string
) => {
  const debugId = `conn_${institutionId}_${Date.now()}`;

  console.log('🏗️ MULTI-STORE: Creating initial connection state', {
    debugId,
    institutionId,
    providerName: connectionData.providerName,
    hasToken: !!bearerToken,
    connectionData: JSON.stringify(connectionData)
  });

  const state = {
    connectionData,
    bearerToken,
    institutionId,
    providerName: connectionData.providerName,
    // Server-only token model: treat connection as connected; token is acquired on-demand server-side
    status: 'connected' as ConnectionStatusType,
    isConnected: true,
    error: null as string | null,
    accounts: [] as WealthicaAccount[],
    isLoadingAccounts: false,
    accountsError: null as string | null,
    lastAccountsFetch: null as Date | null,
    positions: null as unknown[] | null,
    isLoadingPositions: false,
    positionsError: null as string | null,
    lastPositionsFetch: null as Date | null,
    isProcessing: false,
    processingState: 'complete' as const,
    isPersisting: false,
    persistenceError: null as string | null
  };

  return state;
};
